class ProductCardCarousel {
  constructor(element) {
    this.cardMedia = element;
    this.productId = element.dataset.productId;
    this.carousel = element.querySelector('.product-card-carousel');
    this.imagesContainer = element.querySelector('.product-card-carousel__images');
    this.images = element.querySelectorAll('.product-card-carousel__image');
    this.prevButton = element.querySelector('.product-card-carousel__arrow--prev');
    this.nextButton = element.querySelector('.product-card-carousel__arrow--next');
    this.pagination = element.querySelector('[data-pagination]');
    this.bullets = element.querySelectorAll('.product-card-carousel__pagination-bullet');
    this.video = element.querySelector('.product-card-carousel__video');
    this.hasVideo = !!element.dataset.hasVideo && this.video;
    this.currentIndex = 0;
    this.totalImages = this.images.length;
    this.userInteracted = false;

    if (this.totalImages <= 1 && !this.hasVideo) {
      return;
    }

    this.init();
  }

  isMobile() {
    return window.innerWidth <= 749;
  }

  init() {
    const cardWrapper = this.cardMedia.closest('.card-wrapper');

    if (this.prevButton) {
      this.prevButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.userInteracted = true;
        this.showPrevious();
        return false;
      }, true);
      
      this.prevButton.addEventListener('mousedown', (e) => {
        e.stopPropagation();
      }, true);
    }

    if (this.nextButton) {
      this.nextButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.userInteracted = true;
        this.showNext();
        return false;
      }, true);
      
      this.nextButton.addEventListener('mousedown', (e) => {
        e.stopPropagation();
      }, true);
    }

    // Custom play/pause button for video
    if (this.hasVideo && this.video) {
      const toggleBtn = this.cardMedia.querySelector('[data-video-toggle]');
      if (toggleBtn) {
        toggleBtn.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (this.video.paused) {
            this.video.play();
            toggleBtn.classList.remove('is-paused');
          } else {
            this.video.pause();
            toggleBtn.classList.add('is-paused');
          }
        });
        this.video.addEventListener('play', () => toggleBtn.classList.remove('is-paused'));
        this.video.addEventListener('pause', () => toggleBtn.classList.add('is-paused'));
        // Initial state (video may autoplay)
        if (this.video.paused) {
          toggleBtn.classList.add('is-paused');
        } else {
          toggleBtn.classList.remove('is-paused');
        }
      }
    }

    // Show second image on hover only when product has NO video (user hasn't interacted)
    if (cardWrapper && this.totalImages > 1 && !this.hasVideo) {
      cardWrapper.addEventListener('mouseenter', () => {
        if (!this.userInteracted && this.currentIndex === 0) {
          this.currentIndex = 1;
          this.updateActiveImage();
        }
      });

      cardWrapper.addEventListener('mouseleave', () => {
        if (!this.userInteracted) {
          this.currentIndex = 0;
          this.updateActiveImage();
        }
      });
    }

    // Set initial state
    this.updateActiveImage();

    // Mobile: sync pagination with scroll position
    if (this.imagesContainer && this.bullets.length > 0) {
      const updatePaginationFromScroll = () => {
        if (!this.isMobile()) return;
        const containerWidth = this.imagesContainer.offsetWidth;
        const scrollLeft = this.imagesContainer.scrollLeft;
        const index = Math.round(scrollLeft / containerWidth);
        this.currentIndex = Math.min(index, this.totalImages - 1);
        this.updatePagination();
      };

      this.imagesContainer.addEventListener('scroll', updatePaginationFromScroll, { passive: true });
      window.addEventListener('resize', updatePaginationFromScroll);
      updatePaginationFromScroll();
    }
  }

  updatePagination() {
    this.bullets.forEach((bullet, index) => {
      bullet.classList.toggle('product-card-carousel__pagination-bullet--active', index === this.currentIndex);
    });
  }

  showNext() {
    this.currentIndex = (this.currentIndex + 1) % this.totalImages;
    this.updateActiveImage();
  }

  showPrevious() {
    this.currentIndex = (this.currentIndex - 1 + this.totalImages) % this.totalImages;
    this.updateActiveImage();
  }

  updateActiveImage() {
    this.images.forEach((img, index) => {
      if (index === this.currentIndex) {
        img.classList.add('product-card-carousel__image--active');
      } else {
        img.classList.remove('product-card-carousel__image--active');
      }
    });
  }
}

// Initialize all product card carousels (has-carousel) or cards with video (data-has-video)
document.addEventListener('DOMContentLoaded', () => {
  const cardMediaElements = document.querySelectorAll('.card__media.has-carousel, .card__media[data-has-video="true"]');
  cardMediaElements.forEach((cardMedia) => {
    new ProductCardCarousel(cardMedia);
  });
});

// Handle dynamically loaded content (e.g., AJAX pagination)
if (typeof window.Shopify !== 'undefined' && window.Shopify.theme) {
  document.addEventListener('shopify:section:load', () => {
    const cardMediaElements = document.querySelectorAll('.card__media.has-carousel:not([data-initialized]), .card__media[data-has-video="true"]:not([data-initialized])');
    cardMediaElements.forEach((cardMedia) => {
      cardMedia.dataset.initialized = 'true';
      new ProductCardCarousel(cardMedia);
    });
  });
}
